import { render, staticRenderFns } from "./DisplayAmp.vue?vue&type=template&id=37712b1a"
import script from "./DisplayAmp.vue?vue&type=script&lang=js"
export * from "./DisplayAmp.vue?vue&type=script&lang=js"
import style0 from "./DisplayAmp.vue?vue&type=style&index=0&id=37712b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports